namespace TabAurous.Retail {
    export namespace POSApprovalReturnSelectItemsService {
        export const baseUrl = 'Retail/POSApprovalReturnSelectItems';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<POSApprovalReturnItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Retail/POSApprovalReturnSelectItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>POSApprovalReturnSelectItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
